import React, { useEffect, useState } from "react";
import moment from "moment";
import { months } from "../../config";
import { setCedolinoRead, cedoliniDetail } from "../../services/api_dipendenti";
import Backbutton from "../../components/back_button";
import Fetching from "../fetching";


function monthLabel(m) {
  return months.find((x) => x.value === m)?.label ?? String(m);
}

export default function BusteDetailAr(props) {

  const { loading, token, resourceId } = props;
  const [busta, setBusta] = useState({});
  const [fetching, setFetching] = useState(true);


  useEffect(() => {
    if (token && !loading) {
      setFetching(true)
    }
    cedoliniDetail(token, resourceId)
      .then((res) => {
        setBusta(res)
        setFetching(false)
        if (!res.read_at) {
          setCedolinoRead(token, resourceId).then((res) => {
          }).catch((err) => {})
        }
  
      })
      .catch((err) => {
        console.log(err)
        setFetching(false)
      })
  }, [token])


  if (fetching) {
    <Fetching />
  }

  const mese = busta?.mese ?? busta?.month;
  const anno = busta?.anno ?? busta?.year;

  return (
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      {/* top bar */}
      <div className="mt-4 flex items-center justify-between">
        <Backbutton prevLocation={`/areariservata/cedolini`} />
      </div>

      {/* layout */}
      <div className="mt-6 grid grid-cols-1 gap-4 lg:grid-cols-12">
        {/* card info */}
        <div className="lg:col-span-4">
          <div className="rounded-xl border border-gray-200 bg-white shadow-sm overflow-hidden">
            <div className="border-b border-gray-100 px-5 py-4">
              <h3 className="text-sm font-semibold text-gray-900 uppercase">Informazioni</h3>
              <p className="mt-1 text-xs text-gray-500">Dettagli del cedolino</p>
            </div>

            <dl className="divide-y divide-gray-100">
              <div className="px-5 py-4">
                <dt className="text-xs font-semibold text-gray-500 uppercase">Competenza</dt>
                <dd className="mt-1 text-sm font-medium text-gray-900">
                  {monthLabel(mese)} {anno}
                </dd>
              </div>

              {busta?.amount != null && Number(busta.amount) !== 0 && (
                <div className="px-5 py-4">
                  <dt className="text-xs font-semibold text-gray-500 uppercase">Netto</dt>
                  <dd className="mt-1 text-sm font-medium text-gray-900">{busta.amount}</dd>
                </div>
              )}

              {busta?.created_at && (
                <div className="px-5 py-4">
                  <dt className="text-xs font-semibold text-gray-500 uppercase">Caricato il</dt>
                  <dd className="mt-1 text-sm text-gray-700">
                    {moment(busta.created_at).format("DD/MM/YYYY HH:mm")}
                  </dd>
                </div>
              )}

            </dl>
          </div>
        </div>

        {/* viewer */}
        <div className="lg:col-span-8">
          <div className="rounded-xl border border-gray-200 bg-white shadow-sm overflow-hidden">
            <div className="flex items-center justify-between border-b border-gray-100 px-5 py-4">
              <div>
                <p className="mt-1 text-xs text-gray-500">Anteprima PDF</p>
              </div>

              {busta?.download_link && (
                <a
                  href={busta.download_link}
                  target="_blank"
                  rel="noreferrer"
                  className="inline-flex items-center rounded-md bg-white px-3 py-1.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                >
                  Apri in nuova scheda
                </a>
              )}
            </div>

            <div className="bg-gray-50">
              <iframe
                src={busta?.download_link}
                title="Cedolino PDF"
                frameBorder="0"
                className="w-full h-[75vh] md:h-[80vh]"
                allowFullScreen
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}